import { EntityService } from './EntityService';
import { IEntityWithTimerange } from '../types/EntityWithTimerange';

export class RiskImpactLevelService extends EntityService<IEntityWithTimerange> {
    constructor() {
        super(`/RiskImpactLevels`);
    }

    public readAllForLookup(): Promise<IEntityWithTimerange[]> {
        return this.readAll(`?$select=ID,Title,Description,StartUpdatePeriod,EndUpdatePeriod&$orderby=ID desc`);
    }
}